export default __webpack_public_path__ + "static/media/present-a-new-project-idea.37a7b83d.svg";